<template>
  <div>
    <v-container>
      <v-row
        v-for="(settingsGroup, groupName) in groupedSettings"
        :key="groupName"
        class="mb-6"
      >
        <v-col cols="12" class="pa-0">
          <SettingsManager
            :group-name="groupName"
            :group-settings="settingsGroup"
            @setting-updated="fetchSettings"
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import axios from 'axios';
import SettingsManager from './SettingsManager.vue';

export default {
  name: 'SettingsGroupManager',
  components: {
    SettingsManager,
  },
  data() {
    return {
      groupedSettings: {},
    };
  },
  mounted() {
    this.fetchSettings();
  },
  methods: {
    async fetchSettings() {
      try {
        const response = await axios.get('/api/v1/settings/');
        this.groupSettings(response.data);
      } catch (error) {
        console.error('Error fetching settings:', error);
      }
    },
    groupSettings(settings) {
      this.groupedSettings = settings.reduce((acc, setting) => {
        if (!acc[setting.group]) {
          acc[setting.group] = [];
        }
        acc[setting.group].push(setting);
        return acc;
      }, {});
    },
  },
};
</script>
